import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export const useUpdateAvatarsFetilizer = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, file }: { id: string; file: File[] }) => {
			try {
				const formData = createFormData({ file });
				await api.put(`/products/fertilizer/updateAvatars/${id}`, formData);
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar avatar do fertilizante');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['fertilizers'] });
			queryClient.invalidateQueries({ queryKey: ['fertilizer', variables.id] });
		},
		onError: (error) =>
			console.error(
				'Erro ao atualizar avatar do fertilizante:',
				getApiErrorMessage(error, 'Erro ao atualizar avatar do fertilizante')
			),
	});
};
